export const FirebaseConfig = {
	"projectId": "fadiltaxi-3d997",
	"appId": "1:967194435772:web:68ca2e376df359a862b0b9",
	"databaseURL": "https://fadiltaxi-3d997-default-rtdb.firebaseio.com",
	"storageBucket": "fadiltaxi-3d997.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAXUmuie98IwEMv_20fiNuWXdg3HcP1W0c",
	"authDomain": "fadiltaxi-3d997.firebaseapp.com",
	"messagingSenderId": "967194435772",
	"measurementId": "G-SR8E53ETT7",
	"projectNumber": "967194435772",
	"version": "2"
};